<template>
  <v-container class="pt-5">
    <h1>Analyzers</h1>
    <v-btn color="primary" @click="addRow" class="mb-3">Add Analyzer</v-btn>
    <v-simple-table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(analyzer, idx) in analyzers" :key="analyzer.id || idx">
          <td>{{ analyzer.id || '-' }}</td>
          <td>
            <div v-if="!analyzer.editing">{{ analyzer.name }}</div>
            <v-text-field
              v-else
              v-model="analyzer.name"
              dense
              hide-details
              solo
              :disabled="analyzer.saving"
            />
          </td>
          <td>
            <v-switch
              v-if="analyzer.editing"
              v-model="analyzer.active"
              :disabled="analyzer.saving"
              hide-details
              dense
            />
            <v-icon v-else-if="!analyzer.editing && analyzer.active" color="green">mdi-check-circle</v-icon>
            <v-icon v-else-if="!analyzer.editing && !analyzer.active" color="grey">mdi-cancel</v-icon>
          </td>
          <td>
            <v-btn icon v-if="!analyzer.editing" @click="editAnalyzer(analyzer)" :disabled="analyzer.saving">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon v-else @click="saveAnalyzer(analyzer)" :disabled="analyzer.saving">
              <v-icon color="green">mdi-content-save</v-icon>
            </v-btn>
            <v-btn icon @click="confirmDelete(analyzer, idx)" :disabled="analyzer.saving">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
            <v-progress-circular v-if="analyzer.saving" indeterminate size="20" width="2"/>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <ConfirmationDialog
      :show="deleteDialog.show"
      :text="'Delete analyzer?'"
      :subText="deleteDialog.analyzer ? `Are you sure you want to delete analyzer '${deleteDialog.analyzer.name}'?` : ''"
      btnColor="red"
      btnText="Delete"
      @accept="deleteConfirmed"
      @decline="deleteDialog.show = false"
    />
  </v-container>
</template>

<script>
import ax from '@/utils/axios/axios.js'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'

export default {
  name: 'Analyzers',
  components: { ConfirmationDialog },
  data() {
    return {
      analyzers: [],
      loading: false,
      deleteDialog: {
        show: false,
        analyzer: null,
        idx: null
      }
    }
  },
  created() {
    this.fetchAnalyzers()
  },
  methods: {
    async fetchAnalyzers() {
      this.loading = true
      try {
        const res = await ax.get('/analyzer')
        const data = res.data
        this.analyzers = data.map(a => ({ ...a, saving: false, editing: false }))
      } catch (e) {
        alert('Failed to fetch analyzers')
      }
      this.loading = false
    },
    editAnalyzer(analyzer) {
      analyzer.editing = true
    },
    async saveAnalyzer(analyzer) {
      analyzer.saving = true
      try {
        if (analyzer.id) {
          await ax.put(`/analyzer/${analyzer.id}`, { name: analyzer.name, active: analyzer.active })
        } else {
          const res = await ax.post('/analyzer', { name: analyzer.name, active: analyzer.active })
          const newAnalyzer = res.data
          analyzer.id = newAnalyzer.id
        }
        analyzer.editing = false
      } catch (e) {
        alert('Failed to save analyzer')
      }
      analyzer.saving = false
    },
    confirmDelete(analyzer, idx) {
      this.deleteDialog = { show: true, analyzer, idx }
    },
    async deleteConfirmed() {
      const { analyzer, idx } = this.deleteDialog
      if (!analyzer) return
      if (!analyzer.id) {
        this.analyzers.splice(idx, 1)
        this.deleteDialog = { show: false, analyzer: null, idx: null }
        return
      }
      analyzer.saving = true
      try {
        await ax.delete(`/analyzer/${analyzer.id}`)
        this.analyzers.splice(idx, 1)
      } catch (e) {
        alert('Failed to delete analyzer')
      }
      this.deleteDialog = { show: false, analyzer: null, idx: null }
    },
    addRow() {
      this.analyzers.push({ id: null, name: '', active: true, saving: false, editing: true })
    }
  }
}
</script>